module.exports = __webpack_public_path__ + "static/media/simpatia.f4b0275a.jpg";